import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_4 = {
  key: 1,
  class: "text-sm text-red-600"
}
const _hoisted_5 = {
  key: 2,
  class: "bg-white border border-gray-200 shadow-sm rounded-xl p-6"
}
const _hoisted_6 = { class: "grid gap-6 md:grid-cols-2" }
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs text-gray-600"
}
const _hoisted_9 = {
  key: 1,
  class: "text-xs text-green-700"
}
const _hoisted_10 = {
  key: 2,
  class: "text-xs text-red-600"
}
const _hoisted_11 = {
  key: 3,
  class: "mt-2 h-2 w-full rounded-full bg-gray-200"
}
const _hoisted_12 = {
  key: 4,
  class: "mt-3 text-xs text-gray-600"
}
const _hoisted_13 = {
  key: 5,
  class: "mt-3 text-xs text-red-600"
}
const _hoisted_14 = {
  key: 6,
  class: "mt-3 space-y-2"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "md:col-span-2" }
const _hoisted_17 = { class: "inline-flex items-center text-sm font-medium text-gray-700" }
const _hoisted_18 = { class: "md:col-span-2" }
const _hoisted_19 = { class: "grid gap-3 sm:grid-cols-2" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "md:col-span-2" }
const _hoisted_22 = { class: "mt-6 flex items-center gap-3" }
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "mb-6" }, [
        _createElementVNode("h1", { class: "text-3xl font-semibold text-gray-900" }, " Edit Event "),
        _createElementVNode("p", { class: "text-sm text-gray-600 mt-1" }, " Update event details for members. ")
      ], -1)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Loading event... "))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("form", {
                onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateEvent && _ctx.updateEvent(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Title", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event)),
                      class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                      required: "",
                      type: "text"
                    }, null, 512), [
                      [_vModelText, _ctx.form.title]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Location", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.location) = $event)),
                      class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                      type: "text"
                    }, null, 512), [
                      [_vModelText, _ctx.form.location]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Date", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.date) = $event)),
                      class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                      required: "",
                      type: "date"
                    }, null, 512), [
                      [_vModelText, _ctx.form.date]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Type", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.type) = $event)),
                      class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                      type: "text"
                    }, null, 512), [
                      [_vModelText, _ctx.form.type]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Price (GBP)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.price) = $event)),
                      class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                      min: "0",
                      step: "0.01",
                      type: "number"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.form.price,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Ticket URL", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.ticketUrl) = $event)),
                      class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                      type: "url"
                    }, null, 512), [
                      [_vModelText, _ctx.form.ticketUrl]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Banner Image Upload", -1)),
                    _createElementVNode("input", {
                      accept: "image/*",
                      class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                      type: "file",
                      onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleBannerUpload && _ctx.handleBannerUpload(...args)))
                    }, null, 32),
                    _createElementVNode("div", _hoisted_7, [
                      (_ctx.bannerUpload.status === 'uploading')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Uploading banner... " + _toDisplayString(_ctx.bannerUpload.progress) + "% ", 1))
                        : (_ctx.bannerUpload.status === 'success')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Banner uploaded successfully. "))
                          : (_ctx.bannerUpload.status === 'error')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.bannerUpload.error), 1))
                            : _createCommentVNode("", true),
                      (_ctx.bannerUpload.status === 'uploading')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", {
                              class: "h-2 rounded-full bg-black transition-all",
                              style: _normalizeStyle({ width: `${_ctx.bannerUpload.progress}%` })
                            }, null, 4)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.bannerPreview.status === 'loading')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Loading banner preview... "))
                        : (_ctx.bannerPreview.status === 'error')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.bannerPreview.error), 1))
                          : (_ctx.bannerPreview.status === 'ready')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("img", {
                                  alt: "Banner preview",
                                  class: "w-full rounded-lg border border-gray-200",
                                  src: _ctx.bannerPreview.url
                                }, null, 8, _hoisted_15),
                                _createElementVNode("button", {
                                  class: "text-xs font-semibold text-red-600 hover:text-red-700",
                                  type: "button",
                                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.removeBanner && _ctx.removeBanner(...args)))
                                }, " Remove banner ")
                              ]))
                            : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.hidePrice) = $event)),
                        class: "mr-2 h-4 w-4 rounded border-gray-300",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.form.hidePrice]
                      ]),
                      _cache[21] || (_cache[21] = _createTextVNode(" Hide price (show as paid event) "))
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Start Time", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.startTime) = $event)),
                      class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                      type: "time"
                    }, null, 512), [
                      [_vModelText, _ctx.form.startTime]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "End Time", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.endTime) = $event)),
                      class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                      type: "time"
                    }, null, 512), [
                      [_vModelText, _ctx.form.endTime]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Who Should Join", -1)),
                    _createElementVNode("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.whoShouldJoinOptions, (option) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: option,
                          class: "flex items-center gap-2 text-sm text-gray-700"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.whoShouldJoin) = $event)),
                            class: "h-4 w-4 rounded border-gray-300",
                            type: "checkbox",
                            value: option
                          }, null, 8, _hoisted_20), [
                            [_vModelCheckbox, _ctx.form.whoShouldJoin]
                          ]),
                          _createTextVNode(" " + _toDisplayString(option), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[25] || (_cache[25] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Description", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.description) = $event)),
                      class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                      rows: "3"
                    }, null, 512), [
                      [_vModelText, _ctx.form.description]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    class: "inline-flex items-center rounded-lg bg-black px-5 py-2.5 text-sm font-semibold text-white hover:bg-gray-800",
                    disabled: _ctx.bannerUpload.status === 'uploading',
                    type: "submit"
                  }, " Save Changes ", 8, _hoisted_23),
                  _createVNode(_component_router_link, {
                    class: "text-sm font-medium text-gray-600 hover:text-gray-900",
                    to: "/administrator/events"
                  }, {
                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                      _createTextVNode(" Cancel ")
                    ])),
                    _: 1
                  })
                ])
              ], 32)
            ]))
    ])
  ]))
}